// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__33pVO","inner":"Footer_inner__1mocr"};